export const SelectionStackTypes = {
  COMBOBOX: 'COMBOBOX',
  MULTISELECTCHECKBOX: 'MULTISELECTCHECKBOX',
  CHECKBOX: 'CHECKBOX',
  RISKRATING: 'RISKRATING',
  MULTISELECTCOMBOBOX: 'MULTISELECTCOMBOBOX',
} as const;
export type SelectionStackTypes = (typeof SelectionStackTypes)[keyof typeof SelectionStackTypes];

export const BaseStackTypes = {
  TEXT: 'TEXT',
} as const;
export type BaseStackTypes = (typeof BaseStackTypes)[keyof typeof BaseStackTypes];

export const DateRangeTypes = {
  DATETIME: 'DATETIME',
} as const;
export type DateRangeTypes = (typeof DateRangeTypes)[keyof typeof DateRangeTypes];
